<template>
    <div>
        <DCard
            padding
        >
            <ServiceFeeForm
                :errors="errors"
                :service-fee="serviceFee"
                :accounting-products="accountingProducts"
                :market-regions-options="marketRegionsOptions"
                @form-submitted="update"
            />
        </DCard>
    </div>
</template>

<script>
import ServiceFeeForm from '~@/Components/BillingAndAccounting/ServiceFees/Form'

export default {
    name: 'ServiceFeeEdit',
    components: {
        ServiceFeeForm
    },
    props: {
        serviceFee: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        accountingProducts: {
            type: Array,
            default: () => { return [] }
        },
        marketRegionsOptions: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        update (form) {
            form.put(this.$route('tools.service-fees.update', {
                service_fee: this.serviceFee.id
            }))
        }
    }
}
</script>

<style scoped>

</style>
